var map = {
	"./de.json": [
		"./locales/de.json",
		"locales/de-json"
	],
	"./en.json": [
		"./locales/en.json",
		"locales/en-json"
	],
	"./en_GB.json": [
		"./locales/en_GB.json",
		"locales/en_GB-json"
	],
	"./en_dev.json": [
		"./locales/en_dev.json",
		"locales/en_dev-json"
	],
	"./es.json": [
		"./locales/es.json",
		"locales/es-json"
	],
	"./fr.json": [
		"./locales/fr.json",
		"locales/fr-json"
	],
	"./it.json": [
		"./locales/it.json",
		"locales/it-json"
	],
	"./pl.json": [
		"./locales/pl.json",
		"locales/pl-json"
	],
	"./pt.json": [
		"./locales/pt.json",
		"locales/pt-json"
	],
	"./sv.json": [
		"./locales/sv.json",
		"locales/sv-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;